import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgErrorIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "current",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 10L16.5 0.5H5.5L0 10L5.5 19.5H16.5L22 10ZM13.8281 5.75696L11.0001 8.58596L8.17208 5.75696L6.75708 7.17196L9.58608 9.99996L6.75708 12.828L8.17208 14.243L11.0001 11.414L13.8281 14.243L15.2431 12.828L12.4141 9.99996L15.2431 7.17196L13.8281 5.75696Z",
		fill: "current"
	})
});
export default SvgErrorIcon;
